var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44514 5.09148C2.37389 5.85148 2.32389 7.19648 2.77264 7.76898C2.77264 7.76898 2.56139 6.29148 4.45514 4.43773C5.21764 3.69148 5.39389 2.67648 5.12764 1.91523C4.97639 1.48398 4.70014 1.12773 4.46014 0.878982C4.32014 0.732732 4.42764 0.491482 4.63139 0.500232C5.86389 0.555232 7.86139 0.897731 8.71014 3.02773C9.08264 3.96273 9.11014 4.92898 8.93264 5.91148C8.82014 6.53898 8.42014 7.93398 9.33264 8.10523C9.98389 8.22773 10.2989 7.71023 10.4401 7.33773C10.4989 7.18273 10.7026 7.14398 10.8126 7.26773C11.9126 8.51898 12.0064 9.99273 11.7789 11.2615C11.3389 13.714 8.85514 15.499 6.38764 15.499C3.30514 15.499 0.851388 13.7352 0.215138 10.5427C-0.0411123 9.25398 0.0888879 6.70398 2.07639 4.90398C2.22389 4.76898 2.46514 4.88898 2.44514 5.09148Z",
    fill: "url(#paint0_radial_18552_59705)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18552_59705",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.77711 15.5378) rotate(-179.751) scale(8.82346 14.4775)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#F44336"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.ed5266111e2f72ab8d78384451b47609.svg";
export { ForwardRef as ReactComponent };